import React from "react"

export const externalIncludes = [
  {rel: "stylesheet", href: "https://use.typekit.net/huw2vfq.css"},
];
